import { Proposal } from "../../../utils/types/proposals.types";

const proposals: Proposal[] = [
  {
    id: 8,
    title: "Gaz Efficiency",
    description: "we want reduce gaz consumption in our houses.",
    status: "Active",
    result: "Pending",
  },
  {
    id: 7,
    title: "Bad Idea",
    description: "text description about a bad idea.",
    status: "Active",
    result: "Pending",
  },
  {
    id: 6,
    title: "Increase the Dao",
    description: "We think about adding 10 more places in our oraganization.",
    status: "Executed",
    result: "Passed",
  },
  {
    id: 5,
    title: "Proposal number five",
    description: "This is the proposal number five",
    status: "Executed",
    result: "Passed",
  },
  {
    id: 4,
    title: "Dao Token",
    description:
      "We want to create a token and distibute the supply to the users.",
    status: "Executed",
    result: "Failed",
  },
  {
    id: 3,
    title: "Dao investigation",
    description: "We think about maaking an investigation.",
    status: "Executed",
    result: "Passed",
  },
  {
    id: 2,
    title: "Very Bad Idea",
    description:
      "I want to push a bad idea for the organization to be more corfortable.",
    status: "Executed",
    result: "Failed",
  },
  {
    id: 1,
    title: "Increase the Dao",
    description: "We think about adding 10 more places in our oraganization.",
    status: "Executed",
    result: "Passed",
  },
];

export default proposals;
